import { render } from "./HeaderComp.vue?vue&type=template&id=5c6f4cda"
import script from "./HeaderComp.vue?vue&type=script&lang=js"
export * from "./HeaderComp.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__